export default __webpack_public_path__ + "static/media/sticker-n.139428b3.png";